import { flashNews } from "@/mocks/homeNews";
import { SectionHead } from "./bits";

export default function FlashNews() {
  return (
    <section id="kuai" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
        <SectionHead
          eyebrow="一句话快报"
          title="短讯快报：信息密度拉满"
          desc="不铺陈不注水，最新动态一句话讲清楚，方便你在通勤路上快速扫完。"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {flashNews.map((s, i) => (
            <a
              key={s.id}
              href="#lead"
              className="group flex items-start gap-3 rounded-lg border border-background-200 bg-background-100/60 p-4 transition-colors hover:border-primary-300 hover:bg-background-50 cursor-pointer"
            >
              <span className="relative mt-1 flex h-2 w-2 shrink-0 items-center justify-center">
                <span className="absolute inline-flex h-full w-full rounded-full bg-primary-400 opacity-60 animate-ping" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-600" />
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                  {s.title}
                </p>
                <div className="mt-2 flex items-center gap-3 text-xs text-foreground-600">
                  <span className="whitespace-nowrap">{s.time}</span>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line w-4 h-4 flex items-center justify-center" />
                    {s.reads}
                  </span>
                  <span className="ml-auto inline-flex items-center gap-1 text-primary-600 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
                    去看 <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center" />
                  </span>
                </div>
              </div>
              <span className="font-heading text-xs font-bold text-secondary-300">#{String(i + 1).padStart(2, "0")}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}